// import React, { useEffect, useState } from 'react'
// import Footer from '../../components/Footer'
// import Navbar from '../../components/Navbar'
// import FavoritesIcon from '../../assets/icons/nofavorites.png'
// import VoucherCard from '../../components/VoucherCard'

// import AOS from "aos";
// import "aos/dist/aos.css";

// function Favorites() {

//   AOS.init();


//   const [userData, setUserData] = useState(null);
//   const [loading, setLoading] = useState(true); // Add loading state

//   useEffect(() => {
//     const data = sessionStorage.getItem("gbx_data");
//     if (data) {
//       setUserData(JSON.parse(data));
//     }
//     setLoading(false);
//   }, []);

//   if (loading) {
//     return <div>Loading...</div>; // Show loading state
//   }




//   return (
//     <div>
//       <Navbar />
//       <section style={{ marginTop: '120px' }} >
//         <div className='container' >
//           <h2>Favorite</h2>
          

//           {userData?.user?.favorites?.length === 0 ? (
//             <div className="d-flex flex-column align-items-center justify-content-center">
//               <img src={FavoritesIcon} alt="Favorites Icon" />
//               <h3 className="mt-5">No Favorites</h3>
//               <p className="text-dark text-center mt-2">
//                 You can add an item to your <br />
//                 favorites by clicking on the heart icon
//               </p>
//             </div>
//           ) : (

//             <div className='vouchers_div' >
//               { userData?.user?.favorites?.map((product, index) => (
//                <VoucherCard key={index} product={product} isFavorite={true}/>
//             ))}
//               </div>
           
//           )}


//         </div>
//       </section>
//       <Footer />
//     </div>
//   )
// }

// export default Favorites



import React, { useEffect, useState } from 'react';
import Footer from '../../components/Footer';
import Navbar from '../../components/Navbar';
import FavoritesIcon from '../../assets/icons/nofavorites.png';
import VoucherCard from '../../components/VoucherCard';

import AOS from "aos";
import "aos/dist/aos.css";

function Favorites() {

  AOS.init();

  const [userData, setUserData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const data = sessionStorage.getItem("gbx_data");
    if (data) {
      setUserData(JSON.parse(data));
    }
    setLoading(false);
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  // Function to remove a product from favorites and update the state
  const removeFromFavorites = (productId) => {
    const updatedFavorites = userData.user.favorites.filter(
      (product) => product.id !== productId
    );

    // Update the userData state and sessionStorage
    const updatedUserData = { ...userData, user: { ...userData.user, favorites: updatedFavorites } };
    setUserData(updatedUserData);
    sessionStorage.setItem("gbx_data", JSON.stringify(updatedUserData)); // Update session storage
  };

  return (
    <div>
      <Navbar />
      <section style={{ marginTop: '100px' }} >
        <div className='container' >
          <h2 className='mb-2'>Favorites</h2>

          {!userData.user.favorites || userData.user.favorites.length === 0 ? (
            <div className="d-flex flex-column align-items-center justify-content-center">
              <img src={FavoritesIcon} alt="Favorites Icon" />
              <h3 className="mt-5">No Favorites</h3>
              <p className="text-dark text-center mt-2">
                You can add an item to your <br />
                favorites by clicking on the heart icon
              </p>
            </div>
          ) : (
            <div className='vouchers_div' >
              {userData?.user?.favorites?.map((product, index) => (
                <VoucherCard
                  key={index}
                  product={product}
                  isFavorite={true}
                  removeFromFavorites={removeFromFavorites} // Pass remove function to VoucherCard
                />
              ))}
            </div>
          )}
        </div>
      </section>
      <Footer />
    </div>
  );
}

export default Favorites;
